<!--
 * @Author       : dengjianjun
 * @Date         : 2021-11-23 16:07:12
 * @LastEditors  : dengjianjun
 * @LastEditTime : 2021-11-29 15:08:05
 * @Description  : webveiw页
 * @FilePath     : /fe-estrain-customer/src/pages/webview.mpx
-->
<template>
<!-- TODO:有问题 && loadStatus !== LoadStatus.fail-->
  <web-view
    wx:if="{{pageUrl}}"
    src="{{pageUrl}}"
    bindload="loadSuccess"
    binderror="loadFail"
  />
<!--  <empty wx:elif="{{loadStatus === LoadStatus.fail}}" title="{{errorMsg}}" />-->
</template>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { stringifyQuery } from '@didi/es-mpx-shared'

  const LoadStatus = {
    ready: 'ready',
    success: 'success',
    fail: 'fail'
  }

  createPage({
    data: {
      pageUrl: null,
      loadStatus: LoadStatus.ready,
      errorMsg: '',
      LoadStatus,
      initialUrl: ''
    },
    onLoad(options) {
      let { pageUrl: url, title } = options
      delete options.pageUrl
      if (title) {
        mpx.setNavigationBarTitle({ title })
      }

      const pageUrl =
        decodeURIComponent(url) +
        stringifyQuery({
          ...options // 展开传给webview的参数，把这个参数透传给h5
          // token: encodeURIComponent(store.state.login.token || ''),
          // openid: store.state.common.openId || '',
          // uid: store.state.login.uid || 0,
          // phone: store.state.user.userDetail.phone || '',
          // cityId: store.state.user.userDetail.cityId || 0
        })
      console.log('webview', pageUrl)
      this.pageUrl = pageUrl
      this.initialUrl = decodeURIComponent(url)
    },
    methods: {
      loadSuccess(e) {
        this.loadStatus = LoadStatus.success
      },
      loadFail(e) {
        this.loadStatus = LoadStatus.fail
        this.errorMsg = '网页加载失败，请稍后再试'
        // mpx.hideShareMenu()
      }
    }
  })
</script>

<style>
</style>

<script name="json">
  module.exports = {
    // "usingComponents": {
    //   "empty": "@/components/empty/index"
    // },
    navigationBarBackgroundColor: '#ffffff',
    navigationBarTextStyle: 'black'
  }
</script>
